import { Button } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface ButtonProps {
  onClick: () => void
}

export const FillMissingInformationButton = ({ onClick }: ButtonProps) => {
  return (
    <Button iconName="pencil" onClick={onClick}>
      {i18n.t('ats.job_details.promotion.job_boards.buttons.missing_information')}
    </Button>
  )
}

export const PublishButton = ({ onClick }: ButtonProps) => {
  return (
    <Button iconName="upload" onClick={onClick}>
      {i18n.t('ats.job_details.promotion.job_boards.buttons.open')}
    </Button>
  )
}

export const OpenExpiredButton = ({ onClick }: ButtonProps) => {
  return (
    <Button iconName="upload" onClick={onClick}>
      {i18n.t('ats.job_details.promotion.job_boards.buttons.open_expired')}
    </Button>
  )
}

export const ManageOfferButton = ({ onClick }: ButtonProps) => {
  return (
    <Button iconName="pencil" onClick={onClick}>
      {i18n.t('ats.job_details.promotion.job_boards.buttons.manage_offer')}
    </Button>
  )
}

export const RetryButton = ({ onClick }: ButtonProps) => {
  return (
    <Button iconName="refresh" onClick={onClick}>
      {i18n.t('ats.job_details.promotion.job_boards.buttons.retry')}
    </Button>
  )
}
